module.exports = __webpack_public_path__ + "static/media/theme-color-sample4.2a3f92c6.png";